import { IPlayer, isPlayerReady, getCurrentTime, getDuration, isPaused } from "../utils/shaka"
import { useEffect, useState } from "react"

export function usePlayingStatus(player: IPlayer | null) {
  const [hasStarted, setHasStarted] = useState(false)

  const isPlaying = !isPaused(player)

  function hasEnded() {
    if (isPlayerReady(player)) {
      return !isPlaying && getCurrentTime(player) >= getDuration(player)
    }
  }

  useEffect(() => {
    if (!isPlayerReady(player)) {
      return
    }
    if (hasStarted) {
      return
    }
    // Only set hasStarted to true when video is actually playing
    if (isPlaying && getCurrentTime(player) > 0) {
      setHasStarted(true)
    }
  }, [isPlayerReady(player), isPlaying, isPlayerReady(player) && getCurrentTime(player)])

  return { hasEnded: hasEnded(), hasStarted, isPlaying }
}
